import { h, Component, Host, forceUpdate } from '@stencil/core';
import state, { store } from '../../state';
import { getViewportValue } from '../../utils';

@Component({
  tag: 'om-notification-bg-images',
  styleUrl: './bg-images.css',
  scoped: true,
})
export class NotificationBgImages {
  render() {
    const notificationContent = state.content;

    if (!notificationContent?.background) {
      return <Host></Host>;
    }

    return (
      <Host
        style={{
          '--bg-color': getViewportValue(notificationContent.background, 'colour'),
          '--bg-img': `url(${CSS.escape(getViewportValue(notificationContent.background, 'imageUrl') || '')})`,
          'height': '100%',
          'width': '100%',
        }}
      >
        <img
          class="visually-hidden"
          id="om_notification_overlay_a11y_img"
          src={getViewportValue(notificationContent.background, 'imageUrl')}
          alt={getViewportValue(notificationContent.background, 'imageAltText')}
        />
        <div
          class={state.isMobileViewport ? 'current-screen-background is-mobile-viewport' : 'current-screen-background'}
        />
      </Host>
    );
  }

  componentWillRender() {
    if (state.mode !== 'preview') return;
    store.onChange('content', () => forceUpdate(this));
  }
}
